import {BehaviorSubject} from 'rxjs';
import {ExecutionStateEnum} from './execution-state.enum';

export class ExecutionItem {

    public name: string;
    public title: string;
    public text: string;
    public icon: string;
    public progress?: number;
    public error: string;

    private stateSubject = new BehaviorSubject<ExecutionStateEnum>(ExecutionStateEnum.NotStarted);
    public state$ = this.stateSubject.asObservable();

    public get state(): ExecutionStateEnum {
        return this.stateSubject.value;
    }

    public set state(v: ExecutionStateEnum) {
        this.stateSubject.next(v);
    }

    constructor(item: Partial<ExecutionItem>) {
        Object.assign(this, item);
    }
}
